module.exports = __webpack_public_path__ + "static/img/dianshao.db65e51.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/dianshao.png
// module id = EmLW
// module chunks = 4